import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-expand-all-button',
  templateUrl: './expand-all-button.component.html',
  styleUrls: ['../po-node/ponode.component.css'],
})
export class ExpandAllButtonComponent implements OnChanges {
  @Input('allChildrenExpanded') allChildrenExpanded: boolean | undefined;

  expandAllText: string;
  private EXPAND_ALL = 'Alle onderliggende openklappen';
  private COLLAPSE_ALL = 'Alle onderliggende inklappen';

  constructor() {
    this.expandAllText = this.EXPAND_ALL;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.allChildrenExpanded) {
      this.expandAllText = this.COLLAPSE_ALL;
    } else {
      this.expandAllText = this.EXPAND_ALL;
    }
  }
}
